export const GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL || 'http://localhost:8080';

export const USERS_API_URL = `${GATEWAY_URL}/users-management/api/v1`;
export const AUTH_URL = `${GATEWAY_URL}/auth`;
export const CREATE_EVENT_URL = `${GATEWAY_URL}/events-management/api/v1/user/event`;
export const PUBLIC_EVENTS_URL = `${GATEWAY_URL}/events-management/api/v1/event`;
export const ORGANIZER_EVENTS_URL = `${GATEWAY_URL}/events-management/api/v1/user/event`;

export const PAYMENTS_ORDER_URL = `${GATEWAY_URL}/payments-integration/api/v1/order`;
export const PAYMENT_GATEWAYS_CONFIG_URL = `${GATEWAY_URL}/payments-integration/api/v1/organizer/config`;
// Orders under review of the organizer's events
export const ORGANIZER_ORDERS_URL = `${GATEWAY_URL}/payments-integration/api/v1/organizer/orders`;
// Settlement statements: SuperTicket's service fee per event, with their CSV
export const ORGANIZER_SETTLEMENTS_URL = `${GATEWAY_URL}/payments-integration/api/v1/organizer/settlements`;
// Organizers register these in their Bold and Wompi dashboards (payment notifications)
export const PAYMENT_WEBHOOKS_URL = `${GATEWAY_URL}/payments-integration/api/v1/webhooks`;

// Single view of the purchased tickets and resend to the purchase email (public, no session)
export const TICKETS_URL = `${GATEWAY_URL}/ticket-issuance/api/v1/tickets`;

// Door validation of the organizer's events: pairing codes, scanner phones and attendance
export const ORGANIZER_ACCESS_URL = `${GATEWAY_URL}/audience-access-control/api/v1/organizer`;
